// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { IOtpGetAttrs, IOtpValidateAttrs } from 'interfaces/back-office/otp/otp-view.interface'
import { IOtpGet } from 'interfaces/back-office/otp'

const useOtp = () => {
  // Hook
  const {
    otp: { otp_isLoading, otp_isValidateLoading, otp_get: otpGet, otp_validate: otpValidate },
  } = useStores()

  /**
   * @description Get otp
   *
   * @param {IOtpGetAttrs} payload
   *
   * @return {Promise<void>} Promise<boolean|void>
   */
  const otp_get = useCallback(
    (payload: IOtpGetAttrs): Promise<IOtpGet | void> => {
      return new Promise((resolve, reject) => {
        otpGet({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Validate otp
   *
   * @param {IOtpValidateAttrs} payload
   *
   * @return {Promise<void>} Promise<boolean|void>
   */
  const otp_validate = useCallback(
    (payload: IOtpValidateAttrs): Promise<boolean | void> => {
      return new Promise((resolve, reject) => {
        otpValidate({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    otp_isLoading,
    otp_isValidateLoading,
    otp_get,
    otp_validate,
  }
}

export { useOtp }
